module.exports = __webpack_public_path__ + "static/img/title.b0f1f86.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productStage/title.png
// module id = p7n0
// module chunks = 44